import { $axios } from "./config";
import { getBase64Type, openFileInNewBrowser } from "../../util";
import { Buffer } from "buffer";

const url = "/report";

const getAllUserGeneratedReports = async () => {
    return $axios.get(`${url}/getAllUserGeneratedReports`);
};

const getReportDocByReportId = async (generatedReportId, fileName) => {
    // return $axios.get(`${url}/getReportDocByReportId?generatedReportId=${generatedReportId}`);

    const resp = await $axios
        .get(
            `${url}/getReportDocByReportId?generatedReportId=${generatedReportId}`,
            {
                responseType: "arraybuffer",
            }
        )
        .then((response) => {
            const base64URL = Buffer.from(response, "binary").toString(
                "base64"
            );

            var hiddenElement = document.createElement("a");
            hiddenElement.href = getBase64Type("xlsx") + base64URL;
            hiddenElement.download = `${fileName}.xlsx`;
            hiddenElement.click();

            // openFileInNewBrowser(response, false);
            // printJS({ printable: base64URL, type: 'pdf', base64: true })
        })
        .catch((err) => {
            console.log(err);
            return "";
        });
};

export { getReportDocByReportId, getAllUserGeneratedReports };
